import type { SVGProps } from 'react'

export const MagicIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    fill="none"
    focusable="false"
    viewBox="0 0 14 12"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.70451 1.00078L4.66667 1.5L5.70451 1.99922L6.22222 3L6.73993 1.99922L7.77778 1.5L6.73993 1.00078L6.22222 0L5.70451 1.00078ZM9.34306 4.50937L8.54583 3.74063L10.5 1.85625L11.2972 2.625L9.34306 4.50937ZM2.33333 0.75L1.55556 2.25L0 3L1.55556 3.75L2.33333 5.25L3.11111 3.75L4.66667 3L3.11111 2.25L2.33333 0.75ZM10.1111 8.25L8.55556 9L10.1111 9.75L10.8889 11.25L11.6667 9.75L13.2222 9L11.6667 8.25L10.8889 6.75L10.1111 8.25ZM3.5 12L4.4625 11.0719L12.2597 3.55313L13.2222 2.625L12.2597 1.69688L11.4625 0.928125L10.5 0L9.5375 0.928125L1.74028 8.44687L0.777778 9.375L1.74028 10.3031L2.5375 11.0719L3.5 12Z"
      fill="currentColor"
    />
  </svg>
)
